import { render } from "./Approved.vue?vue&type=template&id=95af1ad4&scoped=true"
import script from "./Approved.vue?vue&type=script&lang=js"
export * from "./Approved.vue?vue&type=script&lang=js"

import "./Approved.vue?vue&type=style&index=0&id=95af1ad4&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95af1ad4"]])

export default __exports__